import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { invalidFormValue } from '@components/utils';
import TextField from '@components/text-field/TextField';



interface AddressFormProps {
	streetValue: string | null,
	cityValue: string | null,
	postalCodeValue: string | null,
	onChangeStreet: (value: string | null) => void,
	onChangeCity: (value: string | null) => void,
	onChangePostalCode: (value: string | null) => void,
	required?: boolean,
	showInvalids?: boolean,
}


const AddressForm = (props: AddressFormProps) => {
	const { streetValue, cityValue, postalCodeValue, onChangeStreet, onChangeCity, onChangePostalCode, required = false, showInvalids = false } = props;
	const { t } = useTranslation('forms');
	
	return (
		<div className='component-address-form'>

			<TextField
				label={t('inputLabels.street')}
				required={required}
				value={streetValue ? streetValue : undefined}
				rounded={true}
				maxLength={50}
				onChange={(value: string) =>
					!value && value.length === 0 ? onChangeStreet(null) : onChangeStreet(value)}
				errorMessage={showInvalids && invalidFormValue(streetValue) ? t('validation.requiredField') : undefined} />

			<TextField
				label={t('inputLabels.city')}
				required={required}
				value={cityValue ? cityValue : undefined}
				rounded={true}
				maxLength={50}
				onChange={(value: string) =>
					!value && value.length === 0 ? onChangeCity(null) : onChangeCity(value)}
				errorMessage={showInvalids && invalidFormValue(cityValue) ? t('validation.requiredField') : undefined} />

			<TextField
				label={t('inputLabels.postalCode')}
				required={required}
				value={postalCodeValue ? postalCodeValue : undefined}
				rounded={true}
				maxLength={10}
				onChange={(value: string) =>
					!value && value.length === 0 ? onChangePostalCode(null) : onChangePostalCode(value)}
				errorMessage={showInvalids && invalidFormValue(postalCodeValue) ? t('validation.requiredField') : undefined} />

		</div>
	);
};

export default memo(AddressForm);